const commercialProjects = [
    {
        id: "C001",
        location: "Wadduwa",
        owner: "D S N Enterprises Lanka (Pvt) Ltd",
        capacity: "40kW",
        inverter: "Growatt 40kW Inverter",
        panel: "Trina Solar 615W - 66 Nos",
        images: [
            "../images/projects/C001_01.jpg",
            "../images/projects/C001_02.jpg",
            "../images/projects/C001_03.jpg",
            "../images/projects/C001_04.jpg",
            "../images/projects/C001_05.jpg"
        ]
    },
    {
        id: "C002",
        location: "Moratumulla",
        owner: "Mr. L.P.S. De Silva",
        capacity: "20kW",
        inverter: "Growatt 20kW Inverter",
        panel: "JINKO Solar 590W - 34 Nos",
        images: [
            "../images/projects/C002_01.jpg",
            "../images/projects/C002_02.jpg",
            "../images/projects/C002_03.jpg",
            "../images/projects/C002_04.jpg",
            "../images/projects/C002_05.jpg"
        ]
    },
    {
        id: "C003",
        location: "Panadura",
        owner: "Royal College",
        capacity: "5kW",
        inverter: "Solis 05kW Inverter",
        panel: "JINKO Solar 590W - 9 Nos",
        images: [
            "../images/projects/C003_01.jpg",
            "../images/projects/C003_02.jpg",
            "../images/projects/C003_03.jpg",
            "../images/projects/C003_04.jpg",
            "../images/projects/C003_05.jpg"
        ]
    },
    {
        id: "C004",
        location: "Bandaragama- Rambukkana",
        owner: "Mr. P. Buddhika Perera",
        capacity: "20kW",
        inverter: "Solis 20W Inverter",
        panel: "JINKO Solar 620W - 33 Nos",
        images: [
            "../images/projects/C004_01.jpg",
            "../images/projects/C004_02.jpg",
            "../images/projects/C004_03.jpg",
            "../images/projects/C004_04.jpg",
            "../images/projects/C004_05.jpg"
        ]
    },
    {
        id: "C005",
        location: "Piliyandala - Miriswaththa",
        owner: "Mr. Dhammika Udayakumara",
        capacity: "20kW",
        inverter: "Solis 20W Inverter",
        panel: "JINKO Solar 620W - 33 Nos",
        images: [
            "../images/projects/C005_01.jpg",
            "../images/projects/C005_02.jpg",
            "../images/projects/C005_03.jpg",
            "../images/projects/C005_04.jpg",
            "../images/projects/C005_05.jpg"
        ]
    },
    {
        id: "C006",
        location: "Bolgoda",
        owner: "Mr. R.D.K. Rathnaweera",
        capacity: "15kW",
        inverter: "Solis 15kW Inverter",
        panel: "JINKO 590W - 26 Nos",
        images: [
            "../images/projects/C006_01.jpg",
            "../images/projects/C006_02.jpg",
            "../images/projects/C006_03.jpg",
            "../images/projects/C006_04.jpg",
            "../images/projects/C006_05.jpg"
        ]
    },
    {
        id: "C007",
        location: "Chamara Book Shop Bandaragama",
        owner: "Chamara Book Shop",
        capacity: "20kW",
        inverter: "Solis 20kW Inverter",
        panel: "JINKO 590W - 34 Nos",
        images: [
            "../images/projects/C007_01.jpg",
            "../images/projects/C007_02.jpg",
            "../images/projects/C007_03.jpg",
            "../images/projects/C007_04.jpg",
            "../images/projects/C007_05.jpg"
        ]
    },
    {
        id: "C008",
        location: "Nirmala Hotel - Delduwa, Wadduwa",
        owner: "Nirmala Hotel",
        capacity: "44kW",
        inverter: "Solis 40kW Inverter",
        panel: "JA Solar 550W - 80 Nos",
        images: [
            "../images/projects/C008_01.jpg",
            "../images/projects/C008_02.jpg",
            "../images/projects/C008_03.jpg",
            "../images/projects/C008_04.jpg",
            "../images/projects/C008_05.jpg"
        ]
    },
    {
        id: "C009",
        location: "Horana (Munagama)",
        owner: "Horana Site",
        capacity: "20kW",
        inverter: "Solis 20kW Inverter",
        panel: "JINKO - 36 Nos",
        images: [
            "../images/projects/C009_01.jpg",
            "../images/projects/C009_02.jpg",
            "../images/projects/C009_03.jpg",
            "../images/projects/C009_04.jpg",
            "../images/projects/C009_05.jpg"
        ]
    },
    {
        id: "C010",
        location: "Moratumulla",
        owner: "Moratumulla Site",
        capacity: "40kW",
        inverter: "Solis 40kW Inverter",
        panel: "Jinko Solar 590W - 68 Nos",
        images: [
            "../images/projects/C010_01.jpg",
            "../images/projects/C010_02.jpg",
            "../images/projects/C010_03.jpg",
            "../images/projects/C010_04.jpg"
        ]
    }
];

export default commercialProjects;
